import React from "react";

function HeaderNav({ data = [], navigate }) {
  const renderHeaderNavItem = (item, index) => {
    const { icon, name, badge, to, onClick, component, ...rest } = item;

    const Component = component;

    return (
      <Component
        key={index}
        icon={icon}
        name={name}
        badge={badge}
        to={to}
        onClick={onClick}
        navigate={navigate}
        {...rest}
      />
    );
  };

  const renderHeaderNavGroup = (item, index) => {
    const { icon, name, badge, to, items, component, ...rest } = item;

    const Component = component;

    const groupItems =
      items && Array.isArray(items)
        ? items.map((i, idx) =>
            "items" in i
              ? renderHeaderNavGroup(i, idx)
              : renderHeaderNavItem(i, idx),
          )
        : null;

    return (
      <Component
        key={index}
        icon={icon}
        name={name}
        badge={badge}
        navigate={navigate}
        {...rest}
      >
        {groupItems}
      </Component>
    );
  };

  let splitData = [...data];

  let childrenContent;

  if (splitData.length > 0) {
    const items = splitData.map((item, index) =>
      "items" in item
        ? renderHeaderNavGroup(item, index)
        : renderHeaderNavItem(item, index),
    );

    childrenContent = <div className="flex flex-row">{items}</div>;
  }

  return <div>{childrenContent}</div>;
}

export default HeaderNav;
